import { GenericFailure, GenericFailureParams } from "../../errors/GenericFailure";

type LanguageErrorParams = Pick<GenericFailureParams, "logContext" | "logLevel" | "message" | "statusCode">;
export class LanguageError extends GenericFailure {
  override name = "LanguageError";

  constructor({ message, logContext, logLevel, statusCode }: LanguageErrorParams) {
    super({
      statusCode,
      message,
      logContext,
      logLevel,
    });
  }
}
